export const MASKED_PRICE = '*******';

export const isMaskedPrice = (value: unknown): boolean => value === MASKED_PRICE;
